import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-offline",
  "use": "icon-s-offline-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-offline\"><path d=\"m17 17.595.85.405H17zm-4-1.908 2 .954V18h-2zm-4-1.908 2 .954V18H9zM7 13v5H5v-5zm-4 3v2H1v-2zM19 4v10.439l3 1.418L20.866 18 0 8.143 1.134 6 9 9.715V9h2v1.66l2 .945V6h2v6.55l2 .944V4z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol